var map = {
	"./alipay_logo.jpg": "c7ef",
	"./amex.svg": "8561",
	"./jcb.svg": "7fd1",
	"./master-card.svg": "17f9",
	"./scb-logo.svg": "f3be",
	"./thai_qr.png": "4c5e",
	"./union.svg": "61c7",
	"./visa-2014.svg": "8a6f",
	"./visa-old.svg": "32c9",
	"./visa.svg": "2af7",
	"./wallet-logo.png": "fedc",
	"./wallet-logo.svg": "5fc5",
	"./wechat-pay.png": "06a2",
	"./wechat-pay.svg": "fdfa",
	"./wechat-payment-white.png": "81fa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e974";